export interface ProbeTokenClaims {
    sid: number;
    exp?: number;
    loadMaxKbps?: number;
}

/**
 * Reads the claims the client needs from a probe token. The probe server verifies the signature;
 * the client only needs the session id for its frames and whether the token allows a load.
 */
export function tokenClaims(token: string): ProbeTokenClaims {
    const part = token.split('.')[1] ?? '';
    try {
        const base64 = part
            .replace(/-/g, '+')
            .replace(/_/g, '/')
            .padEnd(Math.ceil(part.length / 4) * 4, '=');
        const json = JSON.parse(atob(base64)) as Record<string, unknown>;
        const claims: ProbeTokenClaims = { sid: Number(json.sid) >>> 0 };
        if (typeof json.exp === 'number') claims.exp = json.exp;
        if (typeof json.loadMaxKbps === 'number') claims.loadMaxKbps = json.loadMaxKbps;
        return claims;
    } catch {
        return { sid: 0 };
    }
}
